import React from "react";
import { useNavigate } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

const MesReservations = () => {
  const navigate = useNavigate();

  return (
    <div className="bg-gray-100 min-h-screen flex justify-center items-center relative">
      <button 
        onClick={() => navigate(-1)} 
        className="absolute top-4 left-4 flex items-center text-blue-600 hover:text-blue-800"
      >
        <ArrowLeft size={24} className="mr-2" />
        Retour
      </button>
      <div className="max-w-4xl w-full p-6 bg-white shadow-lg rounded-lg">
        <h1 className="text-3xl font-bold text-gray-800 mb-4">Mes Réservations</h1>
        <p className="text-gray-600 mb-6">Consultez et gérez vos réservations.</p>

        <div className="space-y-4">
          <div className="p-4 border rounded-lg shadow-md bg-gray-50">
            <h2 className="text-xl font-semibold text-gray-800">Réservation #12345</h2>
            <p className="text-gray-600">Date : 12 Avril 2024</p>
            <p className="text-gray-600">Statut : Confirmée</p>
          </div>

          <div className="p-4 border rounded-lg shadow-md bg-gray-50">
            <h2 className="text-xl font-semibold text-gray-800">Réservation #67890</h2>
            <p className="text-gray-600">Date : 20 Mai 2024</p>
            <p className="text-gray-600">Statut : En attente</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MesReservations;